import script from "./DocumentosEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentosEditar.vue?vue&type=script&setup=true&lang=js"

import "./DocumentosEditar.vue?vue&type=style&index=0&id=46444e63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46444e63"]])

export default __exports__